<template>
    <div class="main-content-container">
        <div class="top-content-container position-relative">
            <b-breadcrumb class="pb-2">
                <b-breadcrumb-item>
                    <span @click="$router.push({ name: 'Resources' })"
                        class="breadcrumb--light font-family-medium text-uppercase">
                        Resources
                    </span>
                </b-breadcrumb-item>
                <b-breadcrumb-item active>
                    <span class="breadcrumb--light font-family-medium text-uppercase">
                        Tips
                    </span>
                </b-breadcrumb-item>
            </b-breadcrumb>
            <div class="d-flex flex-row justify-content-between">
                <h1 class="font-lg font-family-medium primary-dark content-title">
                    Email Tips
                </h1>
            </div>
        </div>
        <b-dropdown-divider class="mt-4 mb-4" />
        <b-row v-if="tips_list.length == 0 && isLoadingTips" style="margin-bottom: 10rem"
            class="mt-5 px-0 py-2 mr-3 ml-3 flex-column">
            <!-- Skeleton loader -->
            <b-row class="" v-for="index in 4" :key="index">
                <b-col md="12" class="mb-3 px-2">
                    <b-card class="p-1" style="height:12rem">
                        <b-skeleton class="mb-3 w-100 h-100"></b-skeleton>
                    </b-card>
                </b-col>
            </b-row>
            <!-- End skeleton loader -->
        </b-row>
        <b-row v-if="tips_list.length > 0 && !isLoadingTips" style="margin-bottom: 10rem" class="mt-5 px-0 py-2 mr-3 ml-3 flex-column">
            <b-col md="12" data-cy="tip-lists" class="mb-3 px-2" v-for="(tip) in tips_list" :key="tip.id">
                <b-card class="p-4" style="height:auto">
                <div id = "delete-tip-btn"  class="d-flex align-items-center justify-content-between" :style="{ paddingBottom: '10px', paddingTop: '10px' }">
                    <p class="primary--text font-size-sm font-family-medium mr-5 mb-0">{{ tip.tipText }}</p>
                    <div class="d-flex justify-content-end align-items-end" v-if="isAdmin()">
                        <div class="mt-3 mb-2">
                            <b-button
                            data-cy="tip-delete-button"
                            @click="deleteTipModal.visible = true; deleteTipModal.tipID = tip.id"
                            class="px-5 py-3 btn-pill btn-danger cursor-pointer"
                            >
                            <b-spinner v-if="isDeleting" style="width: 14px; height: 14px" variant="light" label="Spinning"></b-spinner>
                            <template v-else>Delete</template>
                            </b-button>
                        </div>
                    </div>
                </div>
                <p v-if="tip.isUsed" class="used-tip ">* This tip has been used</p>
                </b-card>
            </b-col>
        </b-row>

        <div v-if="!isLoadingTips && tips_list.length === 0"
            class="no-assigned-msg pr-5 pt-5 pb-5 pl-2 d-flex flex-column justify-content-center align-items-center">
            <h4 class="font-md primary--text font-family-medium">
                No tips found.
            </h4>
        </div>

        <b-avatar size="4.8rem" button v-if="role === 'admin'" @click="showAddTipScreen" data-cy="tip-button-add"
            class="floating-action-btn btn-danger mb-5 position-fixed cursor-pointer">
            <img src="@/assets/icons/floating_plus.svg" alt="" />
        </b-avatar>

        <b-modal id="delete-category-modal" v-model="deleteTipModal.visible" body-class="delete-category-modal-body"
            hide-header hide-footer centered>
            <h1>Are you sure?</h1>
            <h3>Do you want to delete the tip?</h3>
            <div class="buttons-row">
                <div class="buttons-wrapper">
                    <div class="button-wrapper">
                        <b-button class="cancel-button" @click="deleteTipModal.visible = false">
                            Cancel
                        </b-button>
                    </div>
                    <div class="button-wrapper">
                        <b-button class="delete-button" data-cy="tip-delete-button-confirm"
                            @click="deleteTip(deleteTipModal.tipID)" :disabled="isDeleting">Confirm Delete</b-button>
                    </div>
                </div>
            </div>
        </b-modal>

    </div>
</template>
  
<script>
import { mapState } from "vuex";
import {
    deleteTip,
    getTips,
} from "@/apis/common/index";
import { isAdmin, ellipsify } from "@/utils/utils";

export default {
    name: "TipList",
    components: {
    },
    data() {
        return {
            URL: window.URL,
            deleteTipModal: {
                visible: false,
                tipID: ""
            },
            tipText: "",
            isUsed: false,
            tips_list: [],
            tipID: "",
            error: "Some error occured",
            isLoadingTips: true,
            isDeleting: false,
        };
    },
    mounted() {
        this.fetchTipList();
    },
    computed: {
        ...mapState("authModule", ["role", "profileUserId"])
    },
    methods: {
        isAdmin,
        ellipsify,

        fetchTipList() {
            getTips()
                .then(res => {
                    this.tips_list = [...res.data.results];
                })
                .catch(err => {
                    console.log(err);
                    this.isLoadingTips = false;
                })
                .finally(() => {
                    this.isLoadingTips = false;
                });
        },
        showAddTipScreen() {
            this.$router.push({
                name: "AddTip"
            });
        },
        async deleteTip(tipID) {
            this.isDeleting = true
            try {
                await deleteTip(tipID);
                this.$router.push({
                    name: 'TipsList',
                    query: {
                        timestamp: Date.now()
                    }
                });
            } catch (e) {
                console.log(e);
                this.error = "Some error occured. Failed to delete";
            } finally {
                this.isDeleting = false;
                this.deleteTipModal.visible = false;
            }
        }
    }
};
</script>


<style scoped lang="scss">
@import "~@/scss/variables/colors.scss";


.floating-action-btn {
    right: 3rem;
    z-index: 2;
    bottom: 0;
}

.used-tip {
    color: lightgray;
    font-size: small;
    padding-bottom: 0px;
    margin-bottom: 0px;
    padding-top: 5px;
    line-height: 0.2rem;
}
</style>
